<template>
  <div :class="['v2-field', { 'v2-field--has-error': error }]">
    <label v-if="label" :for="inputId" class="v2-field__label">
      {{ label }}
      <span v-if="required" class="v2-field__required" aria-hidden="true">*</span>
    </label>
    <input
      :id="inputId"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :required="required"
      :aria-invalid="Boolean(error)"
      :aria-describedby="describedBy"
      class="v2-input"
      :class="{ 'v2-input--error': error }"
      @input="onInput"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
    />
    <p v-if="helper && !error" :id="helperId" class="v2-field__helper">{{ helper }}</p>
    <p v-if="error" :id="errorId" class="v2-field__error" role="alert">{{ error }}</p>
  </div>
</template>

<script>
let counter = 0;
export default {
  name: "BaseInput",
  props: {
    value: { type: [String, Number], default: "" },
    label: { type: String, default: "" },
    type: { type: String, default: "text" },
    placeholder: { type: String, default: "" },
    helper: { type: String, default: "" },
    error: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    id: { type: String, default: "" },
  },
  data() {
    counter += 1;
    return {
      autoId: `v2-input-${counter}`,
    };
  },
  computed: {
    inputId() {
      return this.id || this.autoId;
    },
    helperId() {
      return `${this.inputId}-helper`;
    },
    errorId() {
      return `${this.inputId}-error`;
    },
    describedBy() {
      if (this.error) return this.errorId;
      if (this.helper) return this.helperId;
      return null;
    },
  },
  methods: {
    onInput(e) {
      this.$emit("input", e.target.value);
    },
  },
};
</script>

<style scoped>
.v2-field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.v2-field__label {
  font-family: var(--font-body);
  font-size: var(--fs-label-md);
  font-weight: var(--fw-medium);
  color: var(--color-text);
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
}

.v2-field__required {
  color: var(--color-error);
}

.v2-field__helper {
  font-size: var(--fs-caption);
  color: var(--color-text-muted);
  margin: 0;
}

.v2-field__error {
  font-size: var(--fs-caption);
  color: var(--color-error);
  margin: 0;
}
</style>
